import { ReactNode } from 'react';

const icons: Record<'info' | 'tools' | 'people' | 'notice' | 'clock' | 'broadcast' | 'discount' | 'cancelCoupon' | 'plus' | 'image' | 'camera' | 'list' | 'chat' | 'question' | 'delete' | 'stats', ReactNode> = {
  stats: <><path d="M4 3v18h17M8 16v-5m5 5V7m5 9v-8" /></>,
  delete: <><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  image: <><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8" cy="8" r="1.5" /><path d="m21 15-5-5L3 21" /></>,
  camera: <><path d="M14.5 5h-5L8 8H3v12h18V8h-5l-1.5-3Z" /><circle cx="12" cy="14" r="3" /></>,
  list: <><path d="M8 6h13M8 12h13M8 18h13M3 6h.1M3 12h.1M3 18h.1" /></>,
  chat: <><path d="M21 15a3 3 0 0 1-3 3H8l-5 3V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v9Z" /><path d="M7 8h10M7 12h7" /></>,
  question: <><circle cx="12" cy="12" r="9" /><path d="M9 9a3 3 0 0 1 6 0c0 2-3 2-3 4m0 3v.1" /></>,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v6m0-10v.1" /></>,
  tools: <><path d="M4 7h16M4 17h16" /><circle cx="8" cy="7" r="2" /><circle cx="16" cy="17" r="2" /></>,
  people: <><circle cx="9" cy="8" r="3" /><path d="M3 20v-2a6 6 0 0 1 12 0v2m1-15a3 3 0 0 1 0 6m2 3a5 5 0 0 1 3 4v2" /></>,
  notice: <><path d="m4 10 13-5v14L4 14v-4Zm0 4 2 6h4l-2-5m12-5v4" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  broadcast: <><rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8m-4-4v4m-2-13 5 3-5 3V8Z" /></>,
  discount: <><path d="m5 19 14-14" /><circle cx="7" cy="7" r="3" /><circle cx="17" cy="17" r="3" /></>,
  cancelCoupon: <path d="M4 8h9a6 6 0 0 1 0 12h-2M4 8l4-4M4 8l4 4" />,
};

export default function LiveToolbarIcon({ name }: { name: keyof typeof icons }) {
  return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{icons[name]}</svg>;
}
